var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 13,
  viewBox: "0 0 15 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m.435 6.946 3.98 5.586c.349.49.933.503 1.302.032 0 0 7.235-9.213 7.894-9.932 1.318-1.439-.659-3.596-1.976-2.158-.66.72-6.589 7.461-6.589 7.461S3.07 5.508 2.411 4.79C1.093 3.351-.883 5.509.435 6.946"
})));
export default SvgCheckmark;